import { initialState, State, Action } from '../store/store';

export const setAPIError = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    apiError: {
      count: state.apiError.count + 1,
      err: data,
    },
  };

  if (nextState.apiError.count >= 3) {
    nextState.hasError = true;
    nextState.error = data;
  }

  return nextState;
};
